<template>
    <div class="nacex-inline-fields">
        <div class="nacex-header p-mb-3">
            <i class="pi pi-truck p-mr-2" style="color: #2196F3;"></i>
            <strong>Campos NACEX</strong>
            <small class="p-ml-2" style="color: #6c757d;">(*) Campos obrigatórios</small>
        </div>

        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3">
                <label>Serviço NACEX *</label>
                <Dropdown
                    v-model="localData.service"
                    :options="services"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Selecione o serviço"
                />
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Data *</label>
                <Calendar v-model="localData.date" dateFormat="dd/mm/yy" :showIcon="true" :disabledDays="[0,6]" />
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Hora Início *</label>
                <Calendar v-model="localData.pickupTimeStart" timeOnly hourFormat="24" :stepMinute="30" />
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Hora Fim *</label>
                <Calendar v-model="localData.pickupTimeEnd" timeOnly hourFormat="24" :stepMinute="30" />
            </div>
        </div>

        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-3" v-if="type === 'shipment'">
                <label>Envio com retorno</label>
                <Dropdown
                    v-model="localData.recurrence"
                    :options="recurrenceOptions"
                    optionLabel="label"
                    optionValue="value"
                />
            </div>
            <div class="p-field p-col-12 p-md-3" v-if="type === 'pickup'">
                <label>Veículo</label>
                <Dropdown v-model="localData.vehicle" :options="vehicles" optionLabel="label" optionValue="value" />
            </div>
            <div class="p-field p-col-12 p-md-3" v-if="type === 'pickup'">
                <label>Nome solicitante</label>
                <InputText v-model="localData.requesterName" />
            </div>
            <div class="p-field p-col-12 p-md-3" v-if="type === 'pickup'">
                <label>E-mail solicitante</label>
                <InputText type="email" v-model="localData.requesterEmail" />
            </div>
        </div>

        <!-- Package info -->
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
                <label>Tipo Embalagem</label>
                <Dropdown
                    v-model="localData.packageType"
                    :options="packageTypes"
                    optionLabel="label"
                    optionValue="value"
                />
            </div>
            <div class="p-field p-col-12 p-md-2">
                <label>Volumes *</label>
                <InputNumber v-model="localData.packages" :min="1" showButtons />
            </div>
            <div class="p-field p-col-12 p-md-2">
                <label>Peso (Kg) *</label>
                <InputNumber v-model="localData.weight" :min="0.1" :minFractionDigits="1" mode="decimal" />
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Tipo pagamento</label>
                <Dropdown
                    v-model="localData.paymentType"
                    :options="paymentTypes"
                    optionLabel="label"
                    optionValue="value"
                />
            </div>
            <div class="p-field p-col-12 p-md-3">
                <label>Referência</label>
                <InputText v-model="localData.reference" />
            </div>
        </div>

        <hr class="separator" />

        <!-- Address blocks -->
        <div class="p-grid">
            <div class="p-col-12 p-md-6">
                <NacexAddressBlock
                    v-model="localData.sender"
                    :title="type === 'pickup' ? 'Destino (Empresa)' : 'Remetente'"
                    :nacex-accounts="nacexAccounts"
                    :selected-account-id="localData.nacex_account_id"
                    @select-account="(acc) => onAccountSelected(acc, 'sender')"
                    :readonly="true"
                />
            </div>
            <div class="p-col-12 p-md-6">
                <NacexAddressBlock
                    v-model="localData.recipient"
                    :title="type === 'pickup' ? 'Local de Recolha (Cliente)' : 'Destinatário'"
                    :locations="addressLocations"
                    :nacex-accounts="nacexAccounts"
                    :prefill-only="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import NacexAddressBlock from '@/components/shipment/NacexAddressBlock.vue';
import nacexAccountsService from '@/services/nacex-accounts.service';

export default {
    name: 'NacexInlineFields',
    components: { NacexAddressBlock },
    props: {
        value: { type: Object, default: () => ({}) },
        type: {
            type: String,
            default: 'shipment',
            validator: v => ['pickup', 'shipment'].includes(v)
        },
        patData: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            services: [
                { label: 'NACEX 10:00H', value: '01' },
                { label: 'NACEX 12:00H', value: '02' },
                { label: 'NACEX 19:00H', value: '08' },
                { label: 'NACEX 08:30H', value: '11' }
            ],
            vehicles: [
                { label: 'Carro/Carrinha (Padrão)', value: 'C' },
                { label: 'Mota (Pequenos)', value: 'M' }
            ],
            packageTypes: [
                { label: 'Pacote / Caixa (Standard)', value: '2' },
                { label: 'Documentos', value: '0' },
                { label: 'Bolsa (Bag)', value: '1' }
            ],
            paymentTypes: [
                { label: 'Origem', value: 'O' },
                { label: 'Destino', value: 'D' },
                { label: 'Terceiro', value: 'T' }
            ],
            recurrenceOptions: [
                { label: 'Sim', value: 'S' },
                { label: 'Não', value: 'N' }
            ],
            addressLocations: {
                clientData: null,
                entityData: null
            },
            nacexAccounts: [],
            localData: this.buildDefaultData()
        };
    },
    watch: {
        localData: {
            handler(val) {
                this.$emit('input', val);
            },
            deep: true
        },
        value: {
            handler(val) {
                if (val && JSON.stringify(val) !== JSON.stringify(this.localData)) {
                    this.localData = { ...this.buildDefaultData(), ...val };
                }
            },
            deep: true
        }
    },
    async mounted() {
        await this.loadNacexAccounts();
        this.initPatData();
    },
    methods: {
        async loadNacexAccounts() {
            try {
                this.nacexAccounts = await nacexAccountsService.getAll();
            } catch (err) {
                console.error("Erro ao carregar contas Nacex", err);
            }
        },
        onAccountSelected(account, target = 'sender') {
            if (account.client_code != '00843') {
                this.localData.paymentType = 'T';
            } else {
                this.localData.paymentType = this.type === 'pickup' ? 'D' : 'O';
            }

            this.localData.nacex_account_id = account.id;
            this.fillSenderWithAccount(account, target);
        },
        fillSenderWithAccount(account, target = 'sender') {
            this.localData[target] = {
                name: account.name,
                address: account.address,
                zip: account.zip,
                city: account.city,
                phone: account.phone,
                email: account.email || '',
                country: account.country || 'PT',
                observations1: this.localData[target]?.observations1 || '',
                observations2: this.localData[target]?.observations2 || ''
            };
        },
        buildDefaultData() {
            const now = this.getNextBusinessDay(this.type === 'pickup' ? 1 : 0);
            return {
                nacex_account_id: null,
                service: '08',
                date: now,
                packages: 1,
                weight: 1.0,
                packageType: '2',
                paymentType: this.type === 'pickup' ? 'D' : 'O',
                reference: '',
                recurrence: 'N',
                pickupTimeStart: new Date(new Date().setHours(9, 0, 0)),
                pickupTimeEnd: new Date(new Date().setHours(18, 0, 0)),
                vehicle: 'C',
                requesterName: 'Ricardo Vieira',
                requesterEmail: 'ricardovieira@circuitcrafters.pt',
                sender: {
                    name: '',
                    address: '',
                    zip: '',
                    city: '',
                    phone: '',
                    email: '',
                    country: 'PT',
                    observations1: '',
                    observations2: ''
                },
                recipient: {
                    name: '', address: '', zip: '', city: '',
                    phone: '', email: '', country: 'PT',
                    observations1: '', observations2: ''
                },
                ...(this.value || {})
            };
        },
        initPatData() {
            if (this.patData) {
                if (this.patData.client) {
                    this.addressLocations.clientData = this.patData.client;
                }
                if (this.patData.entity) {
                    this.addressLocations.entityData = this.patData.entity;
                }
                if (this.patData.reference) {
                    this.localData.reference = this.patData.reference;
                }
                if (this.patData.entity) {
                    this.localData.recipient = { ...this.localData.recipient, ...this.patData.entity };
                } else if (this.patData.client) {
                    this.localData.recipient = { ...this.localData.recipient, ...this.patData.client };
                }

                if (this.type === 'pickup') {
                    this.localData.sender.observations1 = this.patData.externalRef || '';
                } else {
                    const extRef = this.patData.externalRef?.trim() || '';
                    const atcud = (this.patData.atcodeid || '')?.toString().trim();

                    const refText = extRef ? `REF: ${extRef}` : '';
                    const atcudText = atcud ? `AT: ${atcud}` : '';

                    if (refText && atcudText) {
                        this.localData.recipient.observations1 = refText;
                        this.localData.recipient.observations2 = atcudText;
                    } else {
                        this.localData.recipient.observations1 = refText || atcudText;
                        this.localData.recipient.observations2 = '';
                    }
                }
            }
        },
        getNextBusinessDay(offsetDays) {
            const date = new Date();
            date.setDate(date.getDate() + offsetDays);
            while (date.getDay() === 0 || date.getDay() === 6) {
                date.setDate(date.getDate() + 1);
            }
            return date;
        },
        formatTime(dateObj) {
            if (!dateObj) return '09:00';
            const h = dateObj.getHours().toString().padStart(2, '0');
            const m = dateObj.getMinutes().toString().padStart(2, '0');
            return `${h}:${m}`;
        },
        /**
         * Build the NACEX-specific payload with nacex_ prefix for the backend.
         */
        getNacexPayload() {
            const d = this.localData.date;
            const formattedDate = d instanceof Date
                ? `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`
                : d;

            const payload = {
                nacex_account_id: this.localData.nacex_account_id,
                nacex_service_type: this.localData.service,
                nacex_date: formattedDate,
                nacex_reference: this.localData.reference,
                nacex_packages: this.localData.packages,
                nacex_weight: this.localData.weight,
                nacex_package_type: this.localData.packageType,
                nacex_payment_type: this.localData.paymentType,
                nacex_recurrence: this.localData.recurrence,
                nacex_sender_name: this.localData.sender.name,
                nacex_sender_address: this.localData.sender.address,
                nacex_sender_zip: this.localData.sender.zip,
                nacex_sender_city: this.localData.sender.city,
                nacex_sender_phone: this.localData.sender.phone,
                nacex_sender_country: this.localData.sender.country || 'PT',
                nacex_sender_observations1: this.localData.sender.observations1,
                nacex_sender_observations2: this.localData.sender.observations2,
                nacex_recipient_name: this.localData.recipient.name,
                nacex_recipient_address: this.localData.recipient.address,
                nacex_recipient_zip: this.localData.recipient.zip,
                nacex_recipient_city: this.localData.recipient.city,
                nacex_recipient_phone: this.localData.recipient.phone,
                nacex_recipient_email: this.localData.recipient.email,
                nacex_recipient_country: this.localData.recipient.country || 'PT',
                nacex_recipient_observations1: this.localData.recipient.observations1,
                nacex_recipient_observations2: this.localData.recipient.observations2
            };

            if (this.type === 'pickup') {
                payload.nacex_pickup_time_start = this.formatTime(this.localData.pickupTimeStart);
                payload.nacex_pickup_time_end = this.formatTime(this.localData.pickupTimeEnd);
                payload.nacex_vehicle = this.localData.vehicle;
                payload.nacex_requester_name = this.localData.requesterName;
                payload.nacex_requester_email = this.localData.requesterEmail;
            }

            return payload;
        }
    }
};
</script>

<style scoped>
.nacex-inline-fields {
    border: 1px solid #ced4da;
    border-radius: 6px;
    padding: 1rem;
    margin-top: 1rem;
    background-color: #f8f9fa;
}

.nacex-header {
    font-size: 1rem;
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 0.5rem;
}

.separator {
    border: 0;
    border-top: 1px solid #dee2e6;
    margin: 1rem 0;
}

.p-field {
    margin-bottom: 1rem;
}

.p-field label {
    display: block;
    margin-bottom: 0.5rem;
    font-weight: 500;
    color: #495057;
}
</style>
